import React, { useEffect, useRef, useState } from "react";
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { useEntityCrud } from "../../hooks/useEntityCrud";
import { toast } from "react-toastify";
import moment from "moment-jalali";
import { slice } from 'lodash';
import $ from 'jquery';

import ScrollButton from '../Common/ScrollButton';
import AvatarEditor from "react-avatar-editor";
import InputRange from "react-input-range";

const Advertising = () => {


    const { addData } = useEntityCrud("Advertisements/setAdvertisement")
    const { readData } = useEntityCrud("Advertisements/getAllAdvertisement")


    const [list, setList] = useState([])
    const [isCompleted, setIsCompleted] = useState(false)
    const [index, setIndex] = useState(4)
    const initialPosts = slice(list, 0, index)
    const [isLoading, setLoading] = useState(false);


    const [expireDate, setExpireDate] = useState("")
    const [insertDate, setInsertDate] = useState("")
    const [title, setTitle] = useState("")
    const [image, setImage] = useState("")

    const editor = useRef();
    const [imageSrc,setImageSrc] = useState('');
    const [zoom,setZoom] = useState(1.5);
    const [width,setWidth] = useState(0);
    const [height,setHeight] = useState(0);
    const [radius,setRadius] = useState(0);

    const inputRef = useRef()

    useEffect(() => {
        getData();
    }, [])

    const getData = () => {
        setLoading(true)
        readData().then(res => {
            setLoading(false)
            setList(res.data.result)
        })
    }

    function convertToDate(date) {
        if (!date)
            return ""
        return moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("YYYY-MM-DDTHH:mm:ss.SSSZ")
    }

    function getToday() {
        const today = moment().format("jYYYY-jMM-jDD").split("-")
        return {
            year: +today[0],
            month: +today[1],
            day: +today[2]
        }
    }


    function convertDateToInputValue(date) {
        if (!date) return "";
        const shamsiDate = new Date(date).toLocaleDateString("fa-ir-u-nu-latn", {
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        });
        return shamsiDate
    }


    const setFileBase64 = async e => {
        const fileData = await toBase64(e.target.files[0]);
        $('.addBtn_').addClass("base-group-display");
        setImage(fileData);
    }

    const toBase64 = async file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    function handleDelete() {
        $('.addBtn_').removeClass("base-group-display");
        setImage("");
    }



    const handleAddBanner = () => {

        const postedData = {
            "expireDate": convertToDate(expireDate),
            "title": title,
            "image": image,
            "insertDate": convertToDate(insertDate),
            "confirmDate": convertToDate(insertDate),
            "fromDate": convertToDate(insertDate),
            "insertUser": 0,
            "confirmUser": 0,
            "status": true,
        }

        addData(postedData).then(({ data }) => {

            if (data.status) {
                toast.success(' عملیات با موفقیت انجام شد.');
                $('.addBtn_').removeClass("base-group-display");
                setImage("");
                setTitle("");
                setExpireDate("");
                setInsertDate("");
                getData();


            }
            else
                toast.error(data.message);
        })
    }


    const loadMore = () => {
        setIndex(index + 4)
        if (index >= list.length) {
            setIsCompleted(true)
        } else {
            setIsCompleted(false)
        }
    }

    const setCurrentFile = async e => {
        const file = e.target.files[0];
        const fileData = await toBase64(file);
        setWidth(800)
        setHeight(380)
        setRadius(0)
        setImageSrc(fileData);
    }

    const downloadImageCropped = () => {
        if(editor){
            const imageData = editor.current.getImageScaledToCanvas().toDataURL('image/jpeg');
            setImage(imageData);
            $('.addBtn_').addClass("base-group-display");
            setTimeout(() => {
                setImageSrc('');
                setZoom(1.5);
                document.getElementById('modal-file-input').value = '';
            },300)
        }
    }


    return (
        <div className="card">
            <div className="card-header"><div className="card-title">ایجاد تبلیغ جدید</div></div>
            <div className="card-body">
            <div class="alert alert-danger" role="alert">
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                <i class="fa fa-bell me-2" aria-hidden="true"></i>
                کاربر گرامی به منظور نمایش مناسب بنر  ، سایز پیشنهادی

                <strong className="display-8 mx-3 font-weight-bold"  style={{fontWeight:"bold"}}> 380 * 800  </strong>

                می باشد.
            </div>

            <div className="adItem col-md-12 d-flex">
                <div className="col-md-3">
                    <div className="adItem addBtn_ " data-bs-toggle="modal" data-bs-target="#uploadImage">
                        <h1>+</h1>
                    </div>

                    {image && <>
                        <img src={image} />
                        <button onClick={() => handleDelete()} className="delBtn_ ">X</button>
                    </>}

                </div>
                <div className="modal fade" id="uploadImage" tabindex="-1" aria-labelledby="uploadImageLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="modal-title fs-5" id="uploadImageLabel">بارگذاری تصویر</h2>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa fa-close"></i></button>
                            </div>
                            <div className="modal-body text-center">
                                <div className={`row ${imageSrc ? 'mb-2' : ''}`}>
                                    <div className="col-md-6">
                                        <div className="form-group text-start">
                                            <label>انتخاب تصویر</label>
                                            <input type="file" id="modal-file-input" className="form-control" accept="image/jpeg,image/png" onChange={e => setCurrentFile(e)} />
                                        </div>
                                    </div>
                                </div>
                                {!!imageSrc && <>
                                    <AvatarEditor ref={editor} image={imageSrc} width={width} height={height} border={20} color={[255,255,255,0.5]} scale={zoom} rotate={0} borderRadius={radius} />
                                    <p className="mt-3 text-start">زوم</p>
                                    <div dir="ltr" className="mt-1 mb-4"><InputRange maxValue={10} step={0.5} minValue={1} value={zoom} onChange={value => setZoom(value)} /></div>
                                </>}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">لغو</button>
                                {!!imageSrc && <button type="button" className="btn btn-primary" onClick={downloadImageCropped} data-bs-dismiss="modal">بارگذاری تصویر</button>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 d-flex flex-column justify-content-between">
                    <div>
                        <input
                            type="text"
                            required
                            className="form-control my-0"
                            placeholder=" عنوان ... "
                            onChange={(e) => setTitle(e.target.value)}
                            name="title"
                            value={title} />
                        <DatePicker
                            name="dateExpire"
                            required
                            locale="fa"
                            minimumDate={getToday()}
                            shouldHighlightWeekends
                            value={insertDate}
                            onChange={setInsertDate}
                            className="form-control my-1 pb-4"
                            inputPlaceholder=' از تاریخ ...'
                        />
                        <DatePicker
                            name="dateExpire"
                            required
                            locale="fa"
                            minimumDate={getToday()}
                            shouldHighlightWeekends
                            value={expireDate}
                            onChange={setExpireDate}
                            className="form-control mb-4 pb-4"
                            inputPlaceholder=' تا تاریخ ...'
                        />
                    </div>

                    <button className="btn btn-success px-4 mt-4 btn-block"

                        disabled={
                            !title ||
                            !image ||
                            !expireDate ||
                            !insertDate
                        }

                        onClick={() => handleAddBanner()} >ذخیره  </button>
                </div>

            </div>


            <br className="mt-4" />
            <hr className="mt-4" />






            <div className="row position-relative ">


                <div class="alert alert-info" role="alert">
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-hidden="true">×</button>
                    <i class="fa fa-list me-2" aria-hidden="true"></i>     تمامی تبلیغات اضافه شده را میتوانید در لیست زیر مشاهده کنید.
                </div>

                {isLoading ?

                    <div class="lds-facebook" >
                        <div></div>
                        <div></div>
                        <div></div>
                    </div >
                    :

                    <>

                        {initialPosts?.map((item, index) =>
                            <div className=" col-md-3" key={index}>
                                <div className="card" >
                                    <img className="card-img-top" alt={item.title}
                                        src={`https://petromah.sabinarya.com/service/${item.image}`}
                                    />
                                    <div className="card-body">
                                        <h5 className="card-title">عنوان :  {item.title}</h5>
                                        <p className="card-text">  از تاریخ : {convertDateToInputValue(item.fromDate) || "_"}</p>
                                        <p className="card-text">تا تاریخ   : {convertDateToInputValue(item.expireDate)}</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {list?.length > 4 &&
                            <div className='mx-auto my-4 text-center'>
                                {isCompleted ? (
                                    <button
                                        onClick={loadMore}

                                        type="button"
                                        className="btn btn-danger disabled px-4"
                                    >
                                        مورد دیگری وجود ندارد !
                                    </button>
                                ) : (
                                    <button onClick={loadMore} type="button" className="btn btn-primary px-4">
                                        بارگذاری  موارد  بیشتر ...
                                    </button>
                                )}
                            </div>
                        }


                        <ScrollButton />

                    </>
                }

            </div>
        </div>
    </div>
    )
};


export default Advertising;
